import { render } from "./add-group.vue?vue&type=template&id=7a65abbd&scoped=true"
import script from "./add-group.vue?vue&type=script&lang=js"
export * from "./add-group.vue?vue&type=script&lang=js"

import "./add-group.vue?vue&type=style&index=0&id=7a65abbd&scoped=true&lang=css"

import exportComponent from "/Users/aashit.kothari/Documents/jumper-ionic-vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a65abbd"]])

export default __exports__